import React, { lazy } from "react";
import { Redirect, Route } from "react-router-dom";
import Layout from "../../_metronic/layout/Layout";
import EmailNaoVerificadoAlert from "../components/EmailNaoVerificadoAlert";
import AtualizarSessao from "../components/AtualizarSessao";
import LocalizacaoPendenteAlert from "../components/localizacao/LocalizacaoPendenteAlert";

const DashboardPage = lazy(() =>
    import("../pages/home/dashboard/DashboardPage")
);

const PerfilPage = lazy(() =>
    import("../pages/home/perfil/PerfilPage")
);

const ColaboradorPage = lazy(() =>
    import("../pages/home/colaborador/ColaboradorPage")
);

const GroupPage = lazy(() =>
    import("../pages/home/group/GroupPage")
);

const UsuarioPage = lazy(() =>
    import("../pages/home/usuario/UsuarioPage")
);

const TriagemPage = lazy(() =>
    import("../pages/home/triagem/TriagemPage")
);

const AgendamentosGeralPage = lazy(() =>
    import("../pages/home/agendamentos/AgendamentosIndex")
);

const LimpezaPage = lazy(() =>
    import("../pages/home/limpeza/LimpezaPage")
);

const EstacionamentoPage = lazy(() =>
    import("../pages/home/estacionamento/EstacionamentoPage")
);

const CalendarioPage = lazy(() =>
    import("../pages/home/calendario/CalendarioPage")
);

const ClassificacaoProdutoPage = lazy(() =>
    import("../pages/home/classificacao-produto/ClassificacaoProdutoPage")
);

const CupomDescontoPage = lazy(() =>
    import("../pages/home/cupom-desconto/CupomDescontoPage")
);

const ServicoEstacionamentoPage = lazy(() =>
    import("../pages/home/servico-estacionamento/ServicoEstacionamentoPage")
);

const ServicoLimpezaPage = lazy(() =>
    import("../pages/home/servico-limpeza/ServicoLimpezaPage")
);

const ServicoClassificacaoProdutoPage = lazy(() =>
    import("../pages/home/servico-classificacao-produto/ServicoClassificacaoProdutoPage")
);

const SetorPage = lazy(() =>
    import("../pages/home/setor/SetorPage")
);

const VagaMensalPage = lazy(() =>
    import("../pages/home/vaga-mensal/VagaMensalPage")
);

const DescontoPage = lazy(() =>
    import("../pages/home/desconto/DescontoPage")
);

const RelatorioPage = lazy(() =>
    import("../pages/home/relatorio/RelatorioPage")
);

const ConfirmacaoPixPage = lazy(() =>
    import("../pages/home/pix/ConfirmacaoPixPage")
);

const MotoristaPage = lazy(() =>
    import("../pages/home/motorista/MotoristaPage")
);

const ResumePage = lazy(() =>
    import("../pages/home/resumo/ResumePage")
);

const ConfiguracaoAgendamentoPage = lazy(() =>
    import("../pages/home/configuracao-agendamento/ConfiguracaoAgendamentoPage")
);

const CatalogoCargaPage = lazy(() =>
    import("../pages/home/catalogo-carga/CatalogoCargaPage")
);

const AcondicionamentoCargaPage = lazy(() =>
    import("../pages/home/catalogo-carga/acondicionamento/AcondicionamentoCargaPage")
);

const EmpresaFaturaPage = lazy(() =>
    import("../pages/home/empresa-fatura/EmpresaFaturaPage")
);

const MeuPatioPage = lazy(() =>
    import("../pages/home/meu-patio/MeuPatioPage")
);

const BuildingPage = lazy(() =>
    import("../pages/home/BuildingPage")
);

const WelcomePage = lazy(() =>
    import("../pages/home/welcome/WelcomePage")
);

const redirecionarPrefixo = (prefixoAntigo, prefixoNovo) => ({ location }) => (
    <Redirect to={{ ...location, pathname: location.pathname.replace(prefixoAntigo, prefixoNovo) }} />
);

export default function MainPanel() {
    return (
        <Layout>
            <AtualizarSessao />
            <EmailNaoVerificadoAlert />
            <LocalizacaoPendenteAlert />

            <Route exact path="/" component={WelcomePage}/>
            <Route path="/perfil" component={PerfilPage}/>
            <Route path="/dashboard" component={BuildingPage}/>
            <Route path="/colaborador" component={ColaboradorPage}/>
            <Route path="/group" component={GroupPage}/>
            <Route path="/usuario" component={UsuarioPage}/>
            <Route path="/servicos/limpeza" component={LimpezaPage}/>
            <Route path="/servico/limpeza" component={ServicoLimpezaPage}/>
            <Route path="/servico/estacionamento" component={ServicoEstacionamentoPage}/>
            <Route path="/servico/classificacao-produto" component={ServicoClassificacaoProdutoPage}/>
            <Route path="/setor" component={SetorPage}/>
            <Route path="/vaga-mensal" component={VagaMensalPage}/>
            <Route path="/cupom" component={CupomDescontoPage}/>
            <Route path="/desconto" component={DescontoPage}/>
            <Route path="/faturamento/empresas" component={EmpresaFaturaPage}/>
            <Route path="/relatorio" component={BuildingPage}/>
            <Route path="/agendamentos/gestao" component={BuildingPage}/>
            <Route path="/agendamentos/classificacao-produto" component={ClassificacaoProdutoPage}/>
            <Route path="/servicos/estacionamento" component={EstacionamentoPage}/>
            <Route path="/agendamentos/triagem" component={TriagemPage}/>
            <Route path="/programacoes/agendamentos" component={AgendamentosGeralPage}/>
            <Route path="/programacoes/calendario" component={CalendarioPage}/>
            <Route path="/operacoes/estacionamento" component={EstacionamentoPage}/>
            <Route path="/operacoes/classificacao-produto" component={ClassificacaoProdutoPage}/>
            <Route path="/operacoes/limpeza" component={LimpezaPage}/>
            <Route path="/pix" component={ConfirmacaoPixPage}/>
            <Route path="/motorista/cadastro-motorista" component={MotoristaPage}/>
            <Route path="/resumo" component={ResumePage}/>
            <Route path="/parametros-operacionais/cancelamento-automatico" component={ConfiguracaoAgendamentoPage}/>
            <Route path="/parametros-operacionais/produtos" component={CatalogoCargaPage}/>
            <Route path="/parametros-operacionais/acondicionamento" component={AcondicionamentoCargaPage}/>
            <Route path="/configuracao-agendamento" render={() => <Redirect to="/parametros-operacionais/cancelamento-automatico" />}/>
            <Route path="/catalogo-carga" render={redirecionarPrefixo("/catalogo-carga", "/parametros-operacionais")}/>
            <Route path="/meu-patio" component={MeuPatioPage}/>
        </Layout>
    );
}